<template>
  <div class="wrap">
    <div class="login-form-wrap">
      <div class="logo-wrap">
        <img src="/api/logo" alt="logo" />
      </div>
      <span>{{$t('login.email')}}</span>
      <input type="text" v-model="email" :placeholder="$t('login.emailPlaceholder')" />
      <span>{{$t('login.password')}}</span>
      <div class="item">
        <input
          :type="visible ? 'text' : 'password'"
          :class="{error: passwordError}"
          v-model="password"
          @focus="passwordError = false"
          :placeholder="$t('login.passwordPlaceholder')"
        />
        <div class="reveal-password" @click="handlePassword(!visible)">
          <span class="material-icons">{{visible ? 'visibility_off' : 'visibility'}}</span>
        </div>
      </div>
      <small v-if="passwordError">{{$t('login.passwordError')}}</small>

      <div class="button-wrap">
        <div class="button-round" @click="login">
          {{$t('button.login')}} &nbsp;
          <span class="material-icons">arrow_right_alt</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      email: "",
      password: "",
      visible: false,
      passwordError: false
    };
  },
  methods: {
    async login () {
      try {
        if (this.isEmailInvalid()) {
          return;
        }
        this.startLoading();
        let res = await api.adminLogin({
          email: this.email,
          password: this.password
        });
        localStorage.setItem("sid", res.data.sid);
        this.setIsAdmin(true);
        this.setLoggedIn(true);
        this.$router.push("/admin");
      } catch (error) {
        this.handleError();
      }
      this.stopLoading();
    },
    isEmailInvalid () {
      const check = /^(\w+.?)+@(\w+.?)+.\w+$/.test(this.email);
      if (!check) {
        return true;
      } else {
        return false;
      }
    },
    bindSubmitOnEnter (e) {
      if (e.keyCode === 13) {
        this.login();
      }
    },
    handlePassword (val) {
      this.visible = val;
    },
  },
  mounted () {
    window.addEventListener("keyup", this.bindSubmitOnEnter);
  },
  destroyed () {
    window.removeEventListener("keyup", this.bindSubmitOnEnter);
  },
};
</script>

<style scoped lang="scss">
.wrap {
    background: url('/background.png') center center /cover;
    display: flex;
    justify-content: center;
    align-items: center;
}
.login-form-wrap {
  padding: 50px;
  background: var(--main-color);
  border-radius: 60px;
  overflow: visible;
  box-sizing: border-box;
}
.login-form-wrap input {
  border: 1px solid lightgray;
  margin-bottom: 15px;
}
.button-wrap {
  margin: 30px 0 0 0;
  display: flex;
  justify-content: flex-end;
}
.button-round {
  background: var(--button-color-yellow);
}
.logo-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  max-width: 300px;
}
.input {
  margin: 15px 0;
  span {
    margin-bottom: 3px;
  }
  small {
    color: red;
  }
  input {
    border: 1.5px solid transparent;
    transition: border-color 0.2s ease;
    &.error {
      border-color: red;
    }
  }
}
.item {
  position: relative;
}
.reveal-password {
  position: absolute;
  display: inline;
  top: 55%;
  transform: translateY(-50%);
  right: 6px;
  cursor: pointer;
  user-select: none;
  opacity: 0.5;
}
</style>